<!-- Explore guide card (private evaluation) -->
<div class="floating-checklist explore-guide"
  *ngIf="shouldShow && showPrivateEvalBanner"
  [class.is-collapsed]="exploreCollapsed"
  [class.is-paused-slim]="isPausedCompanion && !hasExploreablePrivateTest">

  <!-- Collapsed pill -->
  <button type="button" class="explore-guide-pill" *ngIf="exploreCollapsed" (click)="expandExploreGuide()">
    <mat-icon aria-hidden="true">map</mat-icon>
    <span>{{ explorePillLabel }}</span>
  </button>

  <!-- Expanded card -->
  <div class="explore-guide-card checklist-panel" *ngIf="!exploreCollapsed">
    <div class="panel-header explore-guide-header">
      <div class="header-info">
        <div class="header-icon">
          <mat-icon>{{ hasExploreablePrivateTest ? 'explore' : 'menu_book' }}</mat-icon>
        </div>
        <div>
          <h3>{{ exploreGuideTitle }}</h3>
          <p>{{ exploreGuideSubtitle }}</p>
        </div>
      </div>
      <div class="header-actions">
        <button type="button" class="icon-btn" (click)="collapseExploreGuide()" aria-label="Minimize explore guide">
          <mat-icon>remove</mat-icon>
        </button>
      </div>
    </div>

    <div class="explore-guide-body">
    <p class="explore-guide-orient" *ngIf="showExploreOrientation">
      {{ exploreOrientCopy }}
    </p>

    <div class="explore-guide-section-label" *ngIf="hasExploreablePrivateTest">This computer</div>
    <div class="steps-list explore-guide-steps" *ngIf="hasExploreablePrivateTest">
      <button
        type="button"
        class="step-item clickable explore-stop"
        *ngFor="let stop of privateTestStops"
        [class.completed]="isExploreStopVisited(stop.id)"
        (click)="goExploreStop(stop)">
        <div class="step-icon"
          [class.completed]="isExploreStopVisited(stop.id)"
          [class.upcoming]="!isExploreStopVisited(stop.id)">
          <mat-icon *ngIf="isExploreStopVisited(stop.id)">check</mat-icon>
          <mat-icon *ngIf="!isExploreStopVisited(stop.id)">{{ stop.icon }}</mat-icon>
        </div>
        <span class="explore-stop-copy">
          <strong>{{ stopLabel(stop) }}</strong>
          <em *ngIf="stopHint(stop)">{{ stopHint(stop) }}</em>
        </span>
      </button>
    </div>

    <div class="explore-guide-section-label" *ngIf="hasExploreablePrivateTest">When your timeline is ready</div>
    <div class="steps-list explore-guide-steps" *ngIf="hasExploreablePrivateTest">
      <button
        type="button"
        class="step-item clickable explore-stop"
        *ngFor="let stop of workReplayStops"
        [class.completed]="isExploreStopVisited(stop.id)"
        [class.is-pending]="workReplayCollecting && !isExploreStopVisited(stop.id)"
        [class.is-ready]="isWorkReplayNavigable"
        [disabled]="!isWorkReplayNavigable"
        (click)="goExploreStop(stop)">
        <div class="step-icon"
          [class.completed]="isExploreStopVisited(stop.id)"
          [class.upcoming]="!isExploreStopVisited(stop.id)">
          <mat-icon *ngIf="isExploreStopVisited(stop.id)">check</mat-icon>
          <mat-icon *ngIf="!isExploreStopVisited(stop.id)">{{ stop.icon }}</mat-icon>
        </div>
        <span class="explore-stop-copy">
          <strong>{{ stopLabel(stop) }}</strong>
          <em *ngIf="stopHint(stop)">{{ stopHint(stop) }}</em>
        </span>
      </button>
    </div>

    <div class="explore-guide-section-label explore-guide-section-label--example">Example</div>
    <div class="steps-list explore-guide-steps">
      <button
        type="button"
        class="step-item clickable explore-stop explore-stop--featured"
        *ngFor="let stop of exampleStops"
        [class.completed]="isExploreStopVisited(stop.id)"
        (click)="goExploreStop(stop)">
        <div class="step-icon"
          [class.completed]="isExploreStopVisited(stop.id)"
          [class.upcoming]="!isExploreStopVisited(stop.id)">
          <mat-icon *ngIf="isExploreStopVisited(stop.id)">check</mat-icon>
          <mat-icon *ngIf="!isExploreStopVisited(stop.id)">{{ stop.icon }}</mat-icon>
        </div>
        <span class="explore-stop-copy">
          <strong>{{ stopLabel(stop) }}</strong>
          <em *ngIf="stopHint(stop)">{{ stopHint(stop) }}</em>
        </span>
      </button>
    </div>

    <div class="explore-trends-example" *ngIf="showExampleTrendsPanel">
      <div class="explore-trends-example-toolbar">
        <span class="explore-trends-example-caption">Example view. Not your company data.</span>
        <button type="button" class="explore-trends-hide-btn" (click)="hideExampleTrendsPanel()">
          Hide example
        </button>
      </div>
      <div class="journey-ex journey-ex-trends">
        <div class="journey-ex-trends-head">
          <div>
            <strong>Alex Rivera</strong>
            <em>Last 14 days · Productivity Trends</em>
          </div>
          <span class="journey-ex-trends-meta">2 high-idle · 12 logged</span>
        </div>
        <p class="journey-ex-trends-verdict">
          Recurring — idle ran high on 2 of 12 logged days, not a one-off spike.
        </p>
        <div class="journey-ex-trends-card">
          <div class="journey-ex-trends-label">
            <strong>Idle pattern</strong>
            <span>Logged days · darker = above typical</span>
          </div>
          <div class="journey-ex-trends-strip" aria-hidden="true">
            <span class="journey-ex-trends-median"></span>
            <i class="is-low" style="--h:28%"></i>
            <i class="is-normal" style="--h:42%"></i>
            <i class="is-high" style="--h:88%"></i>
            <i class="is-normal" style="--h:38%"></i>
            <i class="is-low" style="--h:22%"></i>
            <i class="is-normal" style="--h:45%"></i>
            <i class="is-normal" style="--h:36%"></i>
            <i class="is-high" style="--h:76%"></i>
            <i class="is-normal" style="--h:40%"></i>
            <i class="is-low" style="--h:25%"></i>
            <i class="is-normal" style="--h:48%"></i>
            <i class="is-normal" style="--h:33%"></i>
          </div>
          <div class="journey-ex-trends-axis">
            <span>Typical 32%</span>
            <span>Peak 61% · Wed</span>
          </div>
        </div>
        <div class="journey-ex-trends-time">
          <strong>Where did the time go?</strong>
          <ul>
            <li><span>Browsers &amp; web</span><div><i style="--w:42%"></i></div><em>42%</em></li>
            <li><span>Coding &amp; tools</span><div><i style="--w:31%"></i></div><em>31%</em></li>
            <li><span>Communication</span><div><i style="--w:18%"></i></div><em>18%</em></li>
          </ul>
        </div>
      </div>
    </div>
    </div>

    <div class="panel-footer explore-guide-footer">
      <p class="footer-tagline" *ngIf="exploreCtaSupport">{{ exploreCtaSupport }}</p>
      <button type="button"
        class="continue-btn"
        [class.is-promoted]="allCoreStopsVisited"
        (click)="onExplorePrimaryCta()">
        {{ explorePrimaryLabel }}
      </button>
      <button
        *ngIf="showQuietTryCta"
        type="button"
        class="skip-btn explore-try-quiet"
        (click)="onQuietTryCta()">
        {{ quietTryCtaLabel }}
      </button>
      <div class="explore-guide-quiet" *ngIf="hasExploreablePrivateTest">
        <button type="button" class="skip-btn" (click)="toggleWhatYouControl()">
          {{ showWhatYouControl ? 'Hide what you control' : 'What you control' }}
        </button>
        <button type="button" class="skip-btn" (click)="downloadRemovalFromBanner()">
          Remove SuperSee from this computer
        </button>
      </div>
      <div class="explore-guide-wyc" *ngIf="showWhatYouControl && hasExploreablePrivateTest">
        <app-what-you-control [compact]="true" [trackShown]="true"></app-what-you-control>
      </div>
    </div>
  </div>
</div>

<!-- Continue later / paused journey resume -->
<div class="floating-checklist private-eval-banner journey-resume-banner" *ngIf="shouldShow && showJourneyResumeBanner">
  <div class="private-eval-bar">
    <div class="private-eval-copy">
      <strong>{{ resumeBannerTitle }}</strong>
      <span>{{ resumeBannerBody }}</span>
    </div>
    <div class="private-eval-actions">
      <button type="button" class="private-eval-cta" (click)="resumeJourneySetup()">{{ resumeBannerCta }}</button>
    </div>
  </div>
</div>

<!-- Classic checklist -->
<div class="floating-checklist" *ngIf="shouldShow && !showPrivateEvalBanner && !showJourneyResumeBanner">
  <!-- Minimized State -->
  <div class="minimized-badge" *ngIf="state?.minimized" (click)="toggleMinimized()">
    <span class="badge-count">{{ completedCount }}/{{ totalSteps }}</span>
  </div>

  <!-- Expanded Panel -->
  <div class="checklist-panel" *ngIf="state && !state.minimized">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-info">
        <div class="header-icon">
          <mat-icon>trending_up</mat-icon>
        </div>
        <div>
          <h3>Let's Complete Your Setup</h3>
          <p>{{ completedCount }} of {{ totalSteps }} steps completed</p>
        </div>
      </div>
      <div class="header-actions">
        <button class="icon-btn" (click)="toggleExpanded()">
          <mat-icon>{{ expanded ? 'expand_more' : 'expand_less' }}</mat-icon>
        </button>
        <button class="icon-btn" (click)="toggleMinimized()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Steps List -->
    <div class="steps-list" *ngIf="expanded">
      <div
        *ngFor="let step of state.steps; let i = index"
        class="step-item clickable"
        [class.completed]="step.completed"
        [class.current]="state.currentStepIndex === i && !step.completed"
        [class.upcoming]="!step.completed && state.currentStepIndex !== i"
        (click)="goToStep(i)">
        <div class="step-icon"
          [class.completed]="step.completed"
          [class.current]="state.currentStepIndex === i && !step.completed"
          [class.upcoming]="!step.completed && state.currentStepIndex !== i">
          <mat-icon *ngIf="step.completed">check</mat-icon>
          <mat-icon *ngIf="!step.completed">{{ stepIcons[step.id] }}</mat-icon>
        </div>
        <span>{{ step.label }}</span>
      </div>
    </div>

    <!-- Footer -->
    <div class="panel-footer" *ngIf="expanded">
      <p class="footer-tagline">Complete setup to start viewing productivity insights.</p>
      <button class="continue-btn" (click)="continueSetup()">Continue Setup</button>
      <button 
        *ngIf="!state.skipped" 
        class="skip-btn" 
        (click)="skipOnboarding()">
        Skip for now
      </button>
      <button
        *ngIf="state.skipped"
        class="resume-btn"
        (click)="resumeOnboarding()">
        Resume Onboarding
      </button>
    </div>
  </div>
</div>
